import * as actions from '../utils/Constants';
import { apiDeleteWithBodyAndThen } from '../utils/Api';
import { apiRequest, Methods } from '../utils/Api';

const apiGrant = `${process.env.REACT_APP_API_HOST}api/grant/`;
const apiGrants = `${process.env.REACT_APP_API_HOST}api/grants/`;

const getGrantsApi = () =>
    fetch(apiGrants, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        credentials: 'include',
    }).then(res => {
        return res.json();
    });

export const getGrants = (programId = null) => {
    if (programId) {
        return dispatch => dispatch({
            type: actions.GET_GRANTS,
            payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/grants/${programId}`, Methods.get, null, dispatch)
        });
    }
    else {
        return dispatch => dispatch({
            type: actions.GET_GRANTS,
            payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/grants`, Methods.get, null, dispatch)
        });
    }

}

export const searchGrants = (programId, searchText = null) => {
    return dispatch => dispatch({
        type: actions.SEARCH_GRANTS,
        payload: apiRequest(`${process.env.REACT_APP_API_HOST}api/grants/search`, Methods.post, { programId, searchText }, dispatch)
    });
}

export const getGrant = (id) => {
    return {
        type: actions.GET_GRANT,
        payload: fetch(apiGrant + id, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include'
        }).then(res => {
            return res.json();
        })
    }
}

export const deleteGrants = (ids) => ({
    type: actions.DELETE_GRANT,
    payload: apiDeleteWithBodyAndThen(apiGrants, ids, () => getGrantsApi())
});

export const newGrant = () => ({ type: actions.NEW_GRANT })